var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.tag)?_c('sui-label',{style:({ backgroundColor: _vm.tag.color, color: '#FFF' })},[_vm._v(_vm._s(_vm.tag.name))]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }